import React from 'react';
import { cn } from '../lib/utils';

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  hover?: boolean;
}

const Card = React.forwardRef<HTMLDivElement, CardProps>(
  ({ children, className = '', hover = true, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          'bg-surface-light rounded-xl p-4 shadow-elevation-1',
          hover && 'hover:shadow-elevation-2 transition-shadow duration-200',
          className
        )}
        {...props}
      >
        {children}
      </div>
    );
  }
);

Card.displayName = 'Card';

export default Card;